// The "Not set" choice in the Location/Base and Status filters: picks the people whose field is
// blank. The backends recognize the same value when they re-filter at send time, so it has to stay
// in step with NOT_SET in tbn_group_message_sender.py and group_message_sender.py.
export const NOT_SET = '__not_set__'
export const NOT_SET_LABEL = 'Not set'

export const not_set_option = () => ({ value: NOT_SET, text: NOT_SET_LABEL })
